export const SCORE_COLORS = {
  green: '#52C41A',
  yellow: '#FA8C16',
  red: '#F5222D',
  blue: '#42B0D5',
};

export const TOP_INDIVIDUAL_SORT_OPTIONS = [
  {
    label: 'Saved time',
    value: 'saved_time',
  },
  {
    label: 'Net savings',
    value: 'net_time',
  }
];

export const INDIVIDUAL_STATS_PATH = '/individuals';
